export enum CheckoutPlanDisplay {
  TERM_FIRST = 'TERM_FIRST',
  PLAN_FIRST = 'PLAN_FIRST',
}
